import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";

export function useProviderDetailPermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canEditAllProviderFields = permissions.includes("provider.can_edit_all_fields");

  return {
    canEditAllProviderFields,
  };
}
